/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SmsVerifyAnalyticsCountRate } from './smsVerifyAnalyticsCountRate';
import { SmsVerifyAnalyticsCountRateDetails } from './smsVerifyAnalyticsCountRateDetails';

export interface SmsVerifyAnalyticsUndeliveredMessages { 
    carrierViolations?: SmsVerifyAnalyticsCountRateDetails;
    hardBounces?: SmsVerifyAnalyticsCountRateDetails;
    softBounces?: SmsVerifyAnalyticsCountRateDetails;
    deliveryFailures?: SmsVerifyAnalyticsCountRateDetails;
    deliveryReportMissing?: SmsVerifyAnalyticsCountRate;
}
